import React, { useRef, useEffect } from 'react';

type AutoResizeTextareaProps = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
};

const AutoResizeTextarea: React.FC<AutoResizeTextareaProps> = ({
    value,
    onChange,
    placeholder = '',
    className = '',
}) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            const lineHeight = 16;
            if (textareaRef.current.scrollHeight > lineHeight * 3) {
                textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
            } else {
                textareaRef.current.style.height = `${textareaRef.current.scrollHeight -12}px`;
            }
        }
    }, [value]);

    return (
        <textarea
            ref={textareaRef}
            className={`w-full text-sm px-2 border border-gray-300 rounded-md resize-none overflow-hidden leading-none ${className}`}
            style={{
                minHeight: '10px',
                lineHeight: '1rem',
                paddingTop: '8px',
                paddingBottom: '8px',
            }}
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
        />


    );
};

export default AutoResizeTextarea;
